// extracted by mini-css-extract-plugin
module.exports = {"appIcon":"AppIconButton_appIcon__rS2fY"};